import styled from 'styled-components';
import type { IBackgroundApplicationSettings } from '../../types/models/ISectionSettings';

interface StyledSectionBackgroundProps {
  $backgroundSettings: IBackgroundApplicationSettings;
}

export const StyledSectionBackground = styled.div<StyledSectionBackgroundProps>`
  ${({ $backgroundSettings }) => {
    if (!$backgroundSettings.hasBackground || !$backgroundSettings.backgroundImage) {
      return '';
    }

    return `
      ${$backgroundSettings.backgroundColor ? `background-color: ${$backgroundSettings.backgroundColor};` : ''}
      ${$backgroundSettings.backgroundImage ? `background-image: url(${$backgroundSettings.backgroundImage});` : ''}
    `;
  }}
`;

StyledSectionBackground.displayName = 'StyledSectionBackground';
